import {AfterViewInit,Component,ElementRef,EventEmitter,OnInit,Output,Renderer,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {NgbActiveModal,NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal} from 'src/app/core/auth/principal.service';
import {StateStorageService} from 'src/app/core/auth/state-storage.service';
import {LoginService} from 'src/app/core/login/login.service';
import {environment} from 'src/environments/environment';
import {LoginOtp,LoginOtpResponse,OtpErrorCode} from '../../model/login-otp.modal';
import {LanguageChangeService} from '../../services/language-change.service';
import {TdisAlertService} from '../../services/tdis-alert-service';
import {SpotShipmentDeclarationService} from '../../spot-certificate/spot-shipment-declaration.service';
import {CountryMySuffixService} from '.././../../entities/country-my-suffix/country-my-suffix.service';

export class Counter{
  constructor(public min: number,public sec:number) {
      min=0;
      sec=30;
  }
}


@Component({
  selector: 'jhi-login-tdis',
  templateUrl: './login-tdis.component.html',
  styleUrls: ['./login-tdis.component.scss']
})
export class LoginTdisComponent implements OnInit, AfterViewInit {

  @ViewChild("emailIdValidationModal") emailIdValidationModal: ModalDirective;

  @Output() urlChangeEvent = new EventEmitter<string>();
  spotUserEmailId:string
  authenticationError: boolean;
  password: string;
  rememberMe: boolean;
  username: string;
  credentials: any;
  showPopUp: boolean = false;
  loginCheck = false;
  show: boolean = true;
  private ngbModalRef: NgbModalRef;
  quotationBean: any;
  certificateScope: any;
  certificateDto: any;
  showBrowserCloseAlert: boolean = false;
  isLoginProcessStart= true;
  twoFactorEnabled=false;

  @ViewChild("otpModal") otpModal: ModalDirective;
  @ViewChild('otpModal2') otpModal2: ModalDirective;

  @ViewChild('loiOTP') loiOTP: ModalDirective;

  otp: string;
  // counter: {min: number,sec: number}={min: 0,sec: 30}
  counter: Counter=new Counter(0,30);
  intervalId: any;
  startTimer() {
      this.counter = new Counter(0,30);
      clearInterval(this.intervalId);
       this.intervalId = setInterval(() => {
        if (this.counter.sec - 1 == -1) {
          this.counter.min = 0;
          this.counter.sec = 30
        } 
        else this.counter.sec -= 1
        if (this.counter.min === 0 && this.counter.sec == 0) clearInterval(this.intervalId)
      }, 1000)
  
  }
  
  loginOtpResponse: LoginOtpResponse;

  constructor(
      private eventManager: JhiEventManager,
      private loginService: LoginService,
      private stateStorageService: StateStorageService,
      private elementRef: ElementRef,
      private renderer: Renderer,
      private router: Router,
      private jhiAlertService: TdisAlertService,
      public activeModal: NgbActiveModal,
      private activatedRoute: ActivatedRoute,
      private translate: TranslateService,
      public principal: Principal, // public activeModal: NgbActiveModal
      private spotShipmentDeclarationService: SpotShipmentDeclarationService,
      private countryService: CountryMySuffixService,
      private modalService: NgbModal,
    private languageChangeService: LanguageChangeService,

  ) {
      this.credentials = {};

      // if (this.router.url === '/') {
      //     this.router.routeReuseStrategy.shouldReuseRoute = () => false;

      // }
      this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
        const refresh = paramMap.get('refresh');
        if (refresh) {
             
            this.languageChangeService.refreshLanguage();
            window.history.back();
        }
    });
  }
    deployedClient = environment.login;
  ngAfterViewInit() {
     // this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
  }

    ngOnInit() {

        let isReferesh = localStorage.getItem("isRefreshed");
        if(isReferesh==null || isReferesh=='false'){
            localStorage.setItem("isRefreshed","true");
            window.location.reload();
        }



        this.principal.setTitle("Marine");
      // this.twoFactorEnabled=true;
      // this.startTimer();
     // localStorage.removeItem('currentUser');
      this.show = true;
      // this.principal.identity().then(account => {
      //     console.log(account);
      // });
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      if (!isChrome) {
          this.showPopUp = true;
      }

      //for spot client setting data 
      
      // if(localStorage.getItem('spotClientScopeList')){
      //      this.quotationBean = JSON.parse(localStorage.getItem('spotClientScopeList'));
      // }else if(localStorage.getItem('spotClientSelectedScope')){
      //     this.certificateScope = JSON.parse(localStorage.getItem('spotClientSelectedScope'));
      // }
      if(this.stateStorageService.getLocalStorageDataWithExpiry("spotClientEmailId")){
          this.username = this.stateStorageService.getLocalStorageDataWithExpiry("spotClientEmailId");
          this.stateStorageService.resetData('spotClientEmailId');

      }
  //     if(this.stateStorageService.getLocalStorageDataWithExpiry('spotClientScopeList')){
  //         this.quotationBean = this.stateStorageService.getLocalStorageDataWithExpiry('spotClientScopeList')
  //         this.showBrowserCloseAlert = true;
  //    }else if(this.stateStorageService.getLocalStorageDataWithExpiry('spotClientSelectedScope')){
  //        this.certificateScope = this.stateStorageService.getLocalStorageDataWithExpiry('spotClientSelectedScope');
  //        this.showBrowserCloseAlert = true;
  //     }
  //     if(this.quotationBean){
  //         this.certificateDto =  this.quotationBean.certificateRequestDTO;
  //     }else if(this.certificateScope){
  //         this.certificateDto =  this.certificateScope.certificateRequestDTO;
  //     }
  //     if( this.certificateDto){
  //         this.username = this.certificateDto.spotClientEmailId;
  //     }
  }

  cancel() {
      this.credentials = {
          username: null,
          password: null,
          rememberMe: true
      };
      this.authenticationError = false;
      this.activeModal.dismiss('cancel');
  }

  login() {
      this.loginCheck = true;

      if (this.username && this.password ) {
          if(this.isLoginProcessStart){
          console.log("login start" + this.isLoginProcessStart);
          
          this.isLoginProcessStart=false;
          this.loginService
              .login({
                  username: this.username,
                  password: this.password,
                  rememberMe: this.rememberMe
              })
              .then((data:any) => {
                  let res = data.body;
                  if(res.twoFactorEnabled) {
                      this.loginCheck=false;
                      res = res.loginOtpResponse as LoginOtpResponse;
                      if(res.isError) {
                          this.mapError(res);
                      }
                      else {
                          console.log(res);
                          this.twoFactorEnabled=true;
                          this.loginOtpResponse=res;
                          this.startTimer();
                          this.jhiAlertService.success("An OTP has been sent to your email .");
                      }
                      // this.router.navigateByUrl("/otp")
                  } else {
                      this.processLogin();
                  }
              })
              .catch((error) => {
                  this.loginCheck = false;
                  this.authenticationError = true;
                  this.isLoginProcessStart=true;
                  console.log(error);
                  if(error!=undefined && error.error!=undefined)
                  this.jhiAlertService.error( error.error.body, null, null);
              });
          }
      } else {
          this.jhiAlertService.error('Email and Password is required', null, null);
      }

      this.loginCheck = false;
  }

  register() {
      this.activeModal.dismiss('to state register');
      this.router.navigate(['/register']);
  }

  requestResetPassword() {
      this.urlChangeEvent.emit('true');
      this.activeModal.dismiss('to state requestReset');
      this.router.navigate(['/reset', 'request']);
  }

  redirectingToCorrespondingComponent() {
      if (this.principal.userIdentity.authorities[0] === 'CLIENT' || this.principal.userIdentity.authorities[0] === 'CLIENT_STAFF') {
          /* checking client has policy or not
              if : redirecting to 'trade-Details'/'trader' page
              else : internalstaff page
          */
          if (this.principal.userIdentity.isPolicyAvailable) {
              if (this.principal.userIdentity.typeOfClient === 'FREIGHT_FORWARDER') {
                  this.router.navigate(['/certificate/trade-Details']);
              } else {
                  this.router.navigate(['/certificate/trader']);
              }
          } else {
              this.router.navigate(['/user-management/internal-staff']);
          }
      } else if (
          this.principal.userIdentity.authorities[0] === 'BROKER' ||
          this.principal.userIdentity.authorities[0] === 'BROKER_STAFF'
      ) {
          this.router.navigate(['/']);
          // this.router.navigate(['/policy', { outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
      } else if (
          this.principal.userIdentity.authorities[0] === 'ROLE_ADMIN' ||
          this.principal.userIdentity.authorities[0] === 'ADMIN_STAFF'
      ) {
          this.router.navigate(['/user-management/internal-staff']);
      } else if (
          this.principal.userIdentity.authorities[0] === 'AUDIT_USER' ||
          this.principal.userIdentity.authorities[0] === 'AUDIT_USER_STAFF'
      ) {
          this.router.navigate(['/user-management/internal-staff']);
      } else if (
          this.principal.userIdentity.authorities[0] === 'CLAIMANT' 
      ) {
          this.router.navigate(['/claim']);
      }
  }

  isAuthenticated() {
      return this.principal.isAuthenticated();
  }

  showPassword(event) {
      this.show = !this.show;
  }
  navigateToChrome() {
    //   window.location.href = 'https://www.google.com/chrome/';
      this.showPopUp = false;
  }

  signUpPage(){
     this.router.navigateByUrl("/spot_client/client-form"); 
  }
  formPage(){
      this.router.navigateByUrl('/spot-certificate/form');
  }
  // sendEmailForValidation(){
  //   this.spotUserEmailId.trim();
  //   this.loginService.validateSpotClientEmailId(this.spotUserEmailId).subscribe(res =>{
  //       console.log("test client",res.body);
        
  //     if (res.body['message'] == 'SUCCESSFUL') {
  //         sessionStorage.removeItem("spotClientEmailId");
  //         sessionStorage.setItem("spotClientEmailId",this.spotUserEmailId);
  //         console.log("Seesion val ",sessionStorage.getItem("spotClientEmailId"));
  //         this.emailIdValidationModal.hide();
  //         this.router.navigateByUrl('/spot-shipment-declaration/form');
  //     }
  //   }
  //   );
  // }
  // showEmailModal(){
  //     sessionStorage.removeItem("spotClientEmailId");
  //     this.spotUserEmailId = null;
  //     this.username = null;
  //     this.password = null;
  //     this.emailIdValidationModal.show();

  // }
  // hideEmailModal(){
  //     this.spotUserEmailId = null;
  //     this.emailIdValidationModal.hide();
  // }


  otpChange(event){
      if(event.length==6){
        this.otp = event;
      }else{
        this.otp = null;
      }
    }
  
    resendOtp() {
      if(this.counter.min==0 && this.counter.sec!=0){
          this.jhiAlertService.error('Please wait 30 seconds to resend');
          return;
        }

        let loginOtp=this.loginOtpResponse.loginOtp;

        this.loginService.resendOtp(loginOtp).subscribe((res: any) => {
            if(res) {
                res=res as LoginOtpResponse;
            }
            if(res.isError && res.otpErrorCode != OtpErrorCode.NO_ERROR) {
                if(res.otpErrorCode==OtpErrorCode.INVALID_USER) {
                  this.mapError(res);
                  }
                  if(res.otpErrorCode==OtpErrorCode.INVALID_TOKEN) {
                      this.mapError(res);
                  }
                  if(res.otpErrorCode==OtpErrorCode.USER_BLOCKED) {
                      this.mapError(res);
                  }
                  if(res.otpErrorCode==OtpErrorCode.INVALID_OPERATION) {
                      this.mapError(res);
                  }
                  if(res.otpErrorCode==OtpErrorCode.RESEND_DURATION_EXCEED) {
                      this.mapError(res);
                  }
                  if(res.otpErrorCode==OtpErrorCode.RESEND_DURATION_WAIT) {
                    this.jhiAlertService.error(res.message);

                }
          } else {
              this.loginOtpResponse=res;
              this.jhiAlertService.success('Otp has been send to your email , please check your email');
                this.otp='';
                this.twoFactorEnabled=true;
                this.startTimer();
            }
        });

    }
  
    verifyOtp(data) {
      
      if(this.otp && this.otp.length!=6){
          this.jhiAlertService.error('Please enter valid otp');
          return;
        }

        let loginOtp:LoginOtp=this.loginOtpResponse.loginOtp;

        loginOtp.otp=this.otp;

        this.loginService.verifyOtp(loginOtp).subscribe((res: any) => {
            
            if(res.isError&&res.otpErrorCode!=OtpErrorCode.NO_ERROR) {
                if(res.otpErrorCode==OtpErrorCode.INVALID_USER) {
                    this.mapError(res);
                }
                if(res.otpErrorCode==OtpErrorCode.USER_BLOCKED) {
                    this.mapError(res);
                }
                if(res.otpErrorCode==OtpErrorCode.INVALID_OPERATION) {
                    this.mapError(res);
                }
                if(res.otpErrorCode==OtpErrorCode.INVALID_TOKEN) {
                    this.mapError(res);
                }
                if(res.otpErrorCode==OtpErrorCode.INVALID_OTP) {
                    this.jhiAlertService.error(res.message);
                }
                if(res.otpErrorCode==OtpErrorCode.RESEND_DURATION_EXCEED) {
                    this.mapError(res);
                }
                if(res.otpErrorCode==OtpErrorCode.OTP_EXPIRED) {
                    this.mapError(res);
                }
            } else {
              this.loginOtpResponse=res as LoginOtpResponse;
              this.otp='';
              this.twoFactorEnabled=false;
                this.counter = new Counter(0,30);
                this.loginService.processLogin(this.loginOtpResponse.userDTO);
              this.processLogin();
            }
        });
    }

  mapError(res) {
      this.jhiAlertService.error(res.message);
      this.twoFactorEnabled=false;
      this.isLoginProcessStart=true;
      // this.router.navigateByUrl("/login");
  }
  
  processLogin() {
      this.loginCheck=false;
      this.authenticationError=false;
      this.activeModal.dismiss('cancel');
      this.activatedRoute.data=null;

      // before login removeing the local storage data
      this.stateStorageService.resetLanguageKey();
      this.stateStorageService.resetCertificateDTO();
      this.stateStorageService.resetBulkCertificateDTO();
      this.stateStorageService.resetClientDTO();
      this.stateStorageService.resetTypeOfClient();
      localStorage.removeItem('cargoDetail');
      localStorage.removeItem('shippingDetail');
      localStorage.removeItem('tradeDetails');
      localStorage.getItem("");
      this.translate.setDefaultLang('en');

      this.isLoginProcessStart=true;
      
      // removing countries and state
      this.stateStorageService.resetCountries();
      this.stateStorageService.resetStates();
  
      // setting countries in session storage
      this.countryService.query().subscribe(res => {
          if(res && res.body) {
              this.stateStorageService.storeCountries(res);
              let usCon=res.body.find(cn => cn.isoTwo=='US');
              if(usCon!=undefined) {
                  this.countryService.getStatesByCountryId(usCon.id).subscribe(sres => {
                      if(sres&&sres.body) {
                          this.stateStorageService.storeStates(sres);
                      }
                  })
              }
          }
      });


      this.countryService.getCountriesWithContinents().subscribe(res => {
        if(res && res.body) {
            this.stateStorageService.storeCountriesWithContinent(res);
        }
    });


      // let quotationBean ;
      // let certificateScope;
      // let certificateDto
      // if(localStorage.getItem('spotClientScopeList')){
      //      quotationBean = JSON.parse(localStorage.getItem('spotClientScopeList'));
      // }else if(localStorage.getItem('spotClientSelectedScope')){
      //     certificateScope = JSON.parse(localStorage.getItem('spotClientSelectedScope'));
      // }
      // if(quotationBean){
      //     certificateDto =  quotationBean.certificateRequestDTO;
      // }else if(certificateScope){
      //     certificateDto =  certificateScope.certificateRequestDTO;
      // }

      // assiging client DTO to TypeOfClient
      if(this.principal.userIdentity) {
          this.stateStorageService.storeTypeOfClient(this.principal.userIdentity.typeOfClient);
      }
      if(this.router.url==='/register'||/^\/activate\//.test(this.router.url)||/^\/reset\//.test(this.router.url)) {
          // this.router.navigate(['/dashboard']);
          //this.redirectingToCorrespondingComponent();
      
          this.router.navigate(['/dashboard']);
      }


      console.log(this.principal);

      this.eventManager.broadcast({
          name: 'authenticationSuccess',
          content: 'Sending Authentication Success'
      });
      //for spot client to save the request 
      // if( (this.principal.authority =='SPOT_CLIENT') && this.certificateDto && (this.principal.loggedInUserEmail != this.certificateDto.spotClientEmailId)){
      //     this.jhiAlertService.success("Login email id and quotation email are not same", null, null);
      // }else if((this.quotationBean || this.certificateScope ) && (this.principal.authority =='SPOT_CLIENT') && (this.principal.loggedInUserEmail == this.certificateDto.spotClientEmailId) ){
      //     if(this.quotationBean){
      //         this.spotShipmentDeclarationService.saveFailedRequest(this.quotationBean).subscribe(
      //             data => {
      //                 console.log("spotClientScopeList",data);
      //                 this.jhiAlertService.success(data.body.message, null, null);
      //                 localStorage.removeItem("spotClientScopeList");
      //             });
              
      //     }else if(this.certificateScope){ 
      //         this.spotShipmentDeclarationService.saveScopeFilterRule(this.certificateScope).subscribe(
      //             data => {
      //                 console.log("spotClientScopeList",data);
      //                let res= data.body.payload;
      //                 this.router.navigate(["/spot-shipment-declaration/spot-summary-Details",res.requestId,res.id,true,false]);
      //                 localStorage.removeItem("spotClientSelectedScope");
      //             });
              
      //     }      

      // }


      // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
      // // since login is succesful, go to stored previousState and clear previousState
      const redirect=this.stateStorageService.getUrl();
      if(redirect&&redirect!="/") {
          this.stateStorageService.storeUrl(null);
          this.router.navigate([redirect]);
      } else {
          // redirection based on the role
          //this.redirectingToCorrespondingComponent();
          if (this.principal && this.principal.userIdentity && this.principal.userIdentity.isPasswordResetDone && this.principal.userIdentity.isPasswordResetDone == true) {
                this.router.navigate(['/reset/password']);

        } else {
            this.router.navigate(['/dashboard']);
    }
   }
  }
  
  showLogin() {
      this.twoFactorEnabled=false;
      this.loginCheck=false;
      this.isLoginProcessStart=true;
  }

}
